import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import TestPackageList from "src/components/TestPackage";
import { RESOURCE_TYPE } from "src/constant/common";

const TestPackage = () => {
  return (
    <TestPackageList />
  );
};

export default routeGuard(TestPackage, RESOURCE_TYPE.PROJECT_INSTANCE);